import { render, staticRenderFns } from "./ClaimParties.vue?vue&type=template&id=51373033&scoped=true&"
import script from "./ClaimParties.vue?vue&type=script&lang=js&"
export * from "./ClaimParties.vue?vue&type=script&lang=js&"
import style0 from "./ClaimParties.vue?vue&type=style&index=0&id=51373033&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51373033",
  null
  
)

export default component.exports